export default __webpack_public_path__ + "static/media/doctor-attending.7eee8bc2.png";